<script lang="ts" setup>
import SiteFooter from '@/components/SiteFooter.vue'
import SiteHeader from '@/components/SiteHeader.vue'

const { mdAndUp } = useDisplay()
</script>

<template>
  <v-main class="layout">
    <site-header logo-only>
      <template #right>
        <div />
      </template>
    </site-header>
    <div class="layout__content">
      <v-container class="pa-0 h-100">
        <v-row align="center" class="justify-center text-center h-100">
          <v-col class="ma-auto pa-0" cols="12" sm="12" md="9" lg="7">
            <div class="bg-white rounded-xl layout__content__wrapper d-flex flex-column align-center justify-center">
              <slot />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <site-footer color="purple-light" :class="{ 'pt-10': mdAndUp }" />
  </v-main>
</template>

<style lang="scss" scoped>
.layout {
  @include min-width(md) {
    background: $c-purple-light;
  }
  &__content {
    height: 100%;
    max-width: calc(#{$site-width} + #{($base-width * 3 * 2)});
    margin: 0 auto;
    &__wrapper {
      width: 100%;
      height: 750px;
    }
  }
}
</style>
